import React from "react";

/**
 * FormBlock — numbered editorial section wrapper for the registration form
 * ("01 · Quién eres", "02 · Tu punto de partida"...). Mirrors the Chapter
 * marker used across the landing.
 */
const FormBlock = ({ number, title, hint, children, testId }) => (
  <section className="border-t border-[#3F403A]/12 pt-10 md:pt-14" data-testid={testId}>
    <div className="flex items-center gap-4 md:gap-5 mb-3 text-[#63846F]">
      <span className="font-serif italic text-3xl md:text-4xl leading-none">{number}</span>
      <span className="h-px w-10 md:w-14 bg-current opacity-50" aria-hidden />
      <h2 className="overline">{title}</h2>
    </div>
    {hint && (
      <p className="font-sans text-sm text-[#3F403A]/65 mb-8 max-w-xl">{hint}</p>
    )}
    <div className="mt-8 space-y-8">{children}</div>
  </section>
);

export default FormBlock;
